import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Button from "../ui/Button";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import Float from "../ui/Float";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { getSaved } from "../utils/Utils";
import DateInput from "../ui/DateInput";
import SelectBox from "../ui/SelectBox";
import { ENUMS } from "../utils/Enums";
import { ROUTES } from "../utils/Routes";
import { createScreen } from "../hooks/createScreen";
import CustomersController from "../controllers/CustomersController";
import { getSignal } from "../App";

export default function POSSearch(props) {

    const { controller = "", route = "" } = props;
    const [loading, setLoading] = useState(false);

    let _saved = getSaved("pos_search");


    const [search, setSearch] = useState((_saved) ? _saved : {
        log: "O",
        section: "C",
        section_filter: "",
        date: "",
        date_filter: "",
        invoice: "",
        isbn: "",
        customer: "",
        cust_po: "",
        finalize: ""
    })

    const defaultTabs = [
        { label: "log", key: "log", value: search.log },
        { label: "section", key: "section", value: search.section },
        { label: "section_filter", key: "section_filter", value: "" },
        { label: "date", key: "date", value: "" },
        { label: "date_filter", key: "date_filter", value: "" },
        { label: "invoice", key: "invoice", value: "" },
        { label: "isbn", key: "isbn", value: "" },
        { label: "customer", key: "customer", value: "" },
        { label: "cust_po", key: "cust_po", value: "" },
        { label: "finalize", key: "finalize", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "log");



    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }

    useEffect(focusField, [index])

    const status = {
        log: "Choose by letter/number of the Log group to view",
        section: "Search for [H]eld [C]urrent [L]og loc[K]ed [M]ine [O]nline [P]repay [Q]uote  ",
        section_filter: "[A]dj [S]mry [R]trn [V]oid {amount} {tender} {cust po} {disc %20 or %} ",
        date: "Enter a starting date (listed then by invoice # ",
        date_filter: "[A]dj [S]mry [R]trn [V]oid {amount} {tender} {cust po} {disc %20 or %} ",
        invoice: "",
        isbn: "",
        customer: "Name, phone or account#",
        cust_po: "Customer PO# (blank to find latest online 'OL' PO)",
        finalize: "Finalize a group of PrpyRdm transactions (ISBN optional). ",
    }


    useEffect(() => {


        if (loading) {
            return;
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => { next() } },
            { key: KBD.ARROW_UP, action: (e) => { prev() } },

        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.LEFT_BRACKET, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.CTRL_ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ALT_S, KBD.ALT_H, KBD.ALT_L]);
        return cleanup;
    }, [search, index, loading]);



    const statuses = [
        { value: "O", label: "New Online - Rcvd online order", color: "var(--text)" },
        { value: "A", label: "NotifyCust - Ready for pick up", color: "var(--text-green)" },
        { value: "R", label: "ReadyToShp - Picked (locked)", color: "var(--text-olive)" },
        { value: "K", label: "SOSwaiting - Wait until PubDate", color: "var(--text-blue)" },
        { value: "I", label: "MoreToCome - Notify when next rcv", color: "var(--text-teal)" },
        { value: "J", label: "WaitForAll - Notify once complete", color: "var(--text-teal)" },
        { value: "Q", label: "Reserved   - Customer request", color: "var(--text-light)" },
        { value: "X", label: "TextNotice - Customer notified", color: "var(--text-light)" },
        { value: "E", label: "Eml Notice - Customer notified", color: "var(--text-light)" },
        { value: "N", label: "Phoned     - Customer notified", color: "var(--text-light)" },
        { value: "V", label: "VoiceMsg   - Customer notified", color: "var(--text-light)" },
        { value: "Z", label: "Don't call - Don't contact cust", color: "var(--text-light)" },
        { value: "C", label: "CustReply  - Customer responded", color: "var(--text-light)" },
        { value: "S", label: "Shipped    - Completed", color: "var(--text-dim)" },
        { value: "T", label: "Done/taken - Completed", color: "var(--text-dim)" },
        { value: "<", label: "All by date- from oldest", color: "var(--text-light)" },
        { value: ">", label: "All by date- from newest", color: "var(--text-light)" }
    ];



    const selectCustomer = (_search = "", initData = [], newCustomer = false) => {
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        blurField("customer");
        createScreen({
            signal: getSignal(),
            component: <CustomersController controller={controller} is_modal initData={initData} newCustomer={newCustomer} search={_search} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                if (_obj) {
                    runSearch(_obj?.person_id)
                } else {
                    focusField("customer");
                }
            }
        });
    }


    const runSearch = (_value) => {

        switch (index) {
            default:
                alert("TODO")
                break;
        }

        // searchCustomer ()
        // searchPrimaryCondition (ISBN)

    }



    return (

        <Spin style={{ "margin": "0px -10px" }} loading={loading}>

            <div style={{ "width": "570px", "padding": "0px 10px" }}>

                <Float>
                    <div>
                        <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                        <Space height={25} size={10}>
                            <Label className={(index === "log") ? "selected" : ""} width={100}>Log</Label>

                            <SelectBox
                                {...editProps("log")}
                                edit={(index === "log")}
                                className={(index === "log") ? "" : "dim"}
                                allowKeys
                                keyfield="value"
                                width={376}
                                onEnter={(e) => runSearch(e)}
                                options={statuses}
                            />

                            {/* <Input uppercase maxLength={1} width={20} style={{ "textAlign": "center" }} className={(index === "log") ? "" : "dim"} {...editProps("log")} edit={(index === "log")} /> */}
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "section") ? "selected" : ""} width={100}>Section</Label>
                            {/* <Input maxLength={1} chars={["H", "C", "L", "K", "M", "O"]} uppercase width={20} style={{ "textAlign": "center" }} className={(index === "section") ? "" : "dim"} {...editProps("section")} edit={(index === "section")} /> */}

                            <SelectBox
                                {...editProps("section")}
                                edit={(index === "section")}
                                className={(index === "section") ? "" : "dim"}
                                allowKeys
                                keyfield="value"
                                width={95}
                                onEnter={(e) => runSearch(e)}
                                options={ENUMS.POS_SEARCH_SECTIONS}
                            />


                            <Label className={(index === 0) ? "section" : ""} >Filter</Label>
                            <Input width={220} className={(index === "section_filter") ? "" : "dim"} {...editProps("section_filter")} edit={(index === "section_filter")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "date") ? "selected" : ""} width={100}>Date</Label>
                            <DateInput onFilled={() => next()} className={(index === "date") ? "" : "dim"} {...editProps("date")} edit={(index === "date")} />
                            <Label className={(index === 0) ? "date_filter" : ""} >Filter</Label>
                            <Input width={220} className={(index === "date_filter") ? "" : "dim"} {...editProps("date_filter")} edit={(index === "date_filter")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "invoice") ? "selected" : ""} width={100}>Invoice</Label>
                            <Input uppercase maxLength={6} width={95} className={(index === "invoice") ? "" : "dim"} {...editProps("invoice")} edit={(index === "invoice")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "isbn") ? "selected" : ""} width={100}>ISBN</Label>
                            <Input uppercase maxLength={13} width={195} className={(index === "isbn") ? "" : "dim"} {...editProps("isbn")} edit={(index === "isbn")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "customer") ? "selected" : ""} width={100}>Customer</Label>




                            <Input width={376} className={(index === "customer") ? "" : "dim"} {...editProps("customer")} edit={(index === "customer")} onEnter={(e) => selectCustomer(e)} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "cust_po") ? "selected" : ""} width={100}>Cust PO</Label>
                            <Input uppercase maxLength={10} width={195} className={(index === "cust_po") ? "" : "dim"} {...editProps("cust_po")} edit={(index === "cust_po")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "finalize") ? "selected" : ""} width={100}>Finalize</Label>
                            <Input uppercase maxLength={13} width={195} className={(index === "finalize") ? "" : "dim"} {...editProps("finalize")} edit={(index === "finalize")} />
                            <Label>(Held PrpyRdms)</Label>
                        </Space>
                        <div className="shim" /><div className="shim" />
                        <div className="shim" /><div className="shim" />
                        <div className="shim" /><div className="shim" />
                    </div>

                </Float>


                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px" }}>
                    <div className="shim" />

                    <div style={{ "padding": "0px 10px" }}>
                        <Float>
                            <div>&nbsp;</div>
                            <Button type="primary">Search</Button>
                        </Float>

                    </div>


                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <Status><InfoIcon /> {status[index]}</Status>
                </div>


            </div>
        </Spin>


    )
}